import { ImageFocalPoint, Image as ImageType } from '../../../lib/types';
import { FocalPointImage } from '../../FocalPointImage/FocalPointImage';
import { CTA } from '../../atoms/Button/Button.types';
import { Gradient } from '../../atoms/Images/Effects/Gradient';
import { LinkButton } from '../../atoms/Link/LinkButton';

type HeroProps = {
  title: string;
  description?: string | null;
  image: ImageType;
  slim?: boolean;
  imageFocusArea?: ImageFocalPoint | null;
  actions?: CTA[];
  onCtaClick?: (ctaLabel: string) => void;
};

export const Hero = ({
  title,
  description,
  image,
  slim,
  imageFocusArea,
  actions = [],
  onCtaClick = () => {},
}: HeroProps) => {
  return (
    <div
      className={
        slim
          ? 'relative flex min-h-32 w-full items-center justify-center py-7 md:min-h-44'
          : 'relative flex h-80 w-full items-center justify-center md:h-112'
      }
    >
      <FocalPointImage
        focalPoint={imageFocusArea?.focalPoint}
        image={image.url}
        alt={image.alt || ''}
        width={image.width!}
        height={image.height!}
      />
      <div className="main-grid z-10 grid-flow-row justify-between p-4">
        <h1
          className={
            slim
              ? 'page-heading col-span-4 block text-balance text-center text-white md:col-span-8 md:col-start-3'
              : 'hero col-span-4 block text-balance text-center text-white md:col-span-8 md:col-start-3'
          }
        >
          {title}
        </h1>
        {description && (
          <span className="body col-span-4 mt-6 block text-balance text-center text-white md:col-span-6 md:col-start-4">
            {description}
          </span>
        )}
        {actions.length > 0 && (
          <div className="col-span-4 mt-8 flex flex-col items-center justify-center gap-4 md:col-span-8 md:col-start-3 lg:flex-row">
            {actions.map((action) => (
              <LinkButton
                href={action.url}
                openLinkInNewTab={action.openInNewTab ?? false}
                label={action.label}
                size="medium"
                style={action.style}
                className="text-white"
                isDarkMode={true}
                key={`${action.url}-${action.label}`}
                onClick={() => onCtaClick(action.label)}
                ariaLabel={`${title} - ${action.label}`}
              />
            ))}
          </div>
        )}
      </div>
      <Gradient className="absolute top-0 h-full w-full" />
    </div>
  );
};
